<script>
import mortgagesApi from '@/api/MortgagesApi';
import Segment from '@/Segment';
import { hardRefresh } from '@/router';

export default {
  methods: {
    onFileSelected(event) {
      const file = event.target.files[0];
      if (!file) {
        this.isErrorMessage = true;
        this.errorMessage = 'לא נבחר קובץ';
        return;
      }

      if (file.type !== 'application/pdf') {
        this.isErrorMessage = true;
        this.errorMessage = 'ניתן להעלות רק קובצי PDF';
        this.$refs.fileInput.value = '';
        return;
      }

      this.uploadFile(file);
      // Reset the file input
      this.$refs.fileInput.value = '';
    },
    async uploadFile(file) {
      this.uploadingFile = true;
      this.isErrorMessage = false;
      try {
        // Convert file to buffer
        const arrayBuffer = await file.arrayBuffer();
        const buffer = Buffer.from(arrayBuffer);

        await mortgagesApi.uploadMortgageReport(buffer, file.name);
        Segment.trackUserInteraction('NoMortgageDataUploadPage_FileUploaded', {
          fileName: file.name,
          fileSize: file.size,
        });
        // Reload the page after successful upload
        hardRefresh('/mortgage');
        return;
      } catch (error) {
        let errorMessage = 'אירעה שגיאה בהעלאת הקובץ';

        if (error.response && error.response.data && error.response.data.error) {
          const serverError = error.response.data.error;
          switch (serverError) {
          case 'No file uploaded':
            errorMessage = 'לא נבחר קובץ, נסו שוב';
            break;
          case 'Only PDF files are allowed':
            errorMessage = 'ניתן להעלות רק קובצי PDF, נסו שוב';
            break;
          case 'Invalid PDF file':
            errorMessage = 'קובץ PDF לא תקין, נסו שוב';
            break;
          case 'File too large':
            errorMessage = 'הקובץ גדול מדי (מקסימום 10MB), נסו שוב';
            break;
          default:
            errorMessage = 'אירעה שגיאה בהעלאת הקובץ';
          }
        } else if (error.response && error.response.status === 400) {
          // Handle 400 status without specific error message
          errorMessage = 'הקובץ לא תקין, נסו שוב';
        } else if (error.response && error.response.status === 500) {
          // Handle 500 Internal Server Error
          errorMessage = 'שגיאת שרת זמנית, נסו שוב בעוד כמה דקות';
        } else if (error.response && error.response.status >= 500) {
          // Handle any 5xx server errors
          errorMessage = 'שגיאת שרת, נסו שוב מאוחר יותר';
        } else if (error.response && error.response.status >= 400) {
          // Handle any 4xx client errors
          errorMessage = 'הקובץ לא תקין, נסו שוב';
        }

        this.isErrorMessage = true;
        this.errorMessage = errorMessage;

        Segment.trackUserInteraction(`${this.pageName}_FileUploadError`, {
          error: error.message,
          status: error.response?.status,
          serverError: error.response?.data?.error,
        });
      } finally {
        this.uploadingFile = false;
      }
    },
  },
  computed: {
  },
};

</script>
